import TripNotesBlock from "./TripNotesBlock";

export default TripNotesBlock;
